export const FITCODE_URL = '/fit-advisor/index.html';

export const FITCODE_PAGE_TYPE = 'nf-fitcode';
